/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  InputTokensDetails,
  InputTokensDetails$inboundSchema,
  InputTokensDetails$Outbound,
  InputTokensDetails$outboundSchema,
} from "./inputtokensdetails.js";
import {
  OutputTokensDetails,
  OutputTokensDetails$inboundSchema,
  OutputTokensDetails$Outbound,
  OutputTokensDetails$outboundSchema,
} from "./outputtokensdetails.js";

export type Usage = {
  inputTokens: number;
  inputTokensDetails: InputTokensDetails;
  outputTokens: number;
  outputTokensDetails: OutputTokensDetails;
  totalTokens: number;
};

/** @internal */
export const Usage$inboundSchema: z.ZodType<Usage, z.ZodTypeDef, unknown> = z
  .object({
    input_tokens: z.number().int(),
    input_tokens_details: InputTokensDetails$inboundSchema,
    output_tokens: z.number().int(),
    output_tokens_details: OutputTokensDetails$inboundSchema,
    total_tokens: z.number().int(),
  }).transform((v) => {
    return remap$(v, {
      "input_tokens": "inputTokens",
      "input_tokens_details": "inputTokensDetails",
      "output_tokens": "outputTokens",
      "output_tokens_details": "outputTokensDetails",
      "total_tokens": "totalTokens",
    });
  });
/** @internal */
export type Usage$Outbound = {
  input_tokens: number;
  input_tokens_details: InputTokensDetails$Outbound;
  output_tokens: number;
  output_tokens_details: OutputTokensDetails$Outbound;
  total_tokens: number;
};

/** @internal */
export const Usage$outboundSchema: z.ZodType<
  Usage$Outbound,
  z.ZodTypeDef,
  Usage
> = z.object({
  inputTokens: z.number().int(),
  inputTokensDetails: InputTokensDetails$outboundSchema,
  outputTokens: z.number().int(),
  outputTokensDetails: OutputTokensDetails$outboundSchema,
  totalTokens: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    inputTokens: "input_tokens",
    inputTokensDetails: "input_tokens_details",
    outputTokens: "output_tokens",
    outputTokensDetails: "output_tokens_details",
    totalTokens: "total_tokens",
  });
});

export function usageToJSON(usage: Usage): string {
  return JSON.stringify(Usage$outboundSchema.parse(usage));
}
export function usageFromJSON(
  jsonString: string,
): SafeParseResult<Usage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Usage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Usage' from JSON`,
  );
}
